import React, { useState, useEffect } from "react";
import { Box, Button, useDisclosure } from "@chakra-ui/react";
import QuestionForm from "../../components/QuestionForm";

import { useRecoilState } from "recoil"; //取得のみ
import { configJsonState } from "../../states/configJsonState";
import { SushiFooter } from "../../components/suishiFooterComponent";
import { useNavigate } from "react-router-dom";

const EnquetePage = () => {
  const [configStatus, setConfigStatus] = useRecoilState(configJsonState);
  const [walletAddress, setWalletAddress] = useState("");
  const [purpose, setPurpose] = useState("");
  const [informationSource, setInformationSource] = useState("");
  const [satisfaction, setSatisfaction] = useState(""); // Add this line
  const [submitted, setSubmitted] = useState(false);
  const [feedback, setFeedback] = useState("");

  const indexPageMainStyle: React.CSSProperties = {
    minHeight: "calc(100vh - 60px)",
    textAlign: "center",
    fontFamily: "Noto Sans JP,sans-serif",
    width: "100%",
    height: "100vh",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    flex: 1,
    color: "#FFFBFB",
    backgroundImage: `url(${configStatus.backgroundImage})`,
  };

  useEffect(() => {
    window.addEventListener(
      "message",
      function (e) {
        if (e.origin !== "https://www.sushitop.io") {
          return;
        }
        setWalletAddress(e.data[1]);
      },
      false
    );
  }, []);

  const openLink = () => {
    window.open(
      "https://www.sushitop.io" +
        "/0beta/browserwallet_signer" +
        "/index.html?pageurl=" +
        `${encodeURIComponent(window.location.href)}`
    );
  };

  const navigate = useNavigate(); // 追加: useNavigateフックを使う

  const handleFormSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
  };

  return (
    <div style={indexPageMainStyle}>
      <Box p={5}>
        {/* <Button onClick={openLink} colorScheme="blue" mb={4}>
          クリックしてウォレットアドレスを取得
        </Button> */}
        
        {/* 
          action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdvM9Bk5zHJyHCv4O6-mguJ28kzpCWROhaS7ixLLkxw5MUAXQ/formResponse"
          method="post"
          target="to_success"
          onSubmit={handleFormSubmit}
        > */}
          <QuestionForm
            walletAddress={walletAddress}
            setWalletAddress={setWalletAddress}
            purpose={purpose}
            setPurpose={setPurpose}
            informationSource={informationSource}
            setInformationSource={setInformationSource}
            satisfaction={satisfaction}
            setSatisfaction={setSatisfaction}
            feedback={feedback} // Pass the feedback state to QuestionForm
            setFeedback={setFeedback} // Pass the setFeedback function to QuestionForm
          />

        {/* </form> */}
        <iframe
          name="to_success"
          style={{ display: "none" }}
          onLoad={() => {
            if (submitted) navigate("/3"); // 修正: バックアップページへのパスに変更
          }}
        />
      </Box>
      <SushiFooter
        footerPragraph1="powered by"
        footerPragraph2="- Creating a Token-Graph Marketing Culture -"
      />
    </div>
  );
};

export default EnquetePage;
